import React from "react";
import { Grid, TextField, MenuItem, Select } from "@mui/material";

function ExamPaperInfo({
  examPapers,
  loading,
  selectedId,
  setSelectedId,
}: {
  examPapers: any[];
  loading: boolean;
  selectedId: string;
  setSelectedId: (id: string) => void;
}) {
  const selectedPaper = examPapers.find((e) => e.id === selectedId);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <Select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          displayEmpty
          fullWidth
          size="small"
          disabled
          sx={{
            borderRadius: 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2
            }
          }}
        >
          <MenuItem value="" disabled>
            {loading ? "Loading..." : "Select Exam Paper"}
          </MenuItem>
          {examPapers.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.title}
            </MenuItem>
          ))}
        </Select>
      </Grid>

      {selectedPaper && (
        <>
          <Grid item xs={12} sm={4}>
            <TextField
              value={selectedPaper.totalSections}
              label="Total Sections"
              size="small"
              fullWidth
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={selectedPaper.totalMarks}
              label="Total Marks"
              size="small"
              fullWidth
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />
          </Grid>

          {/* Row 2: Two items */}
          <Grid item xs={12} sm={6}>
            <TextField
              value={selectedPaper.totalQuestions}
              label="Total Questions"
              size="small"
              fullWidth
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={selectedPaper.questionTypes?.join(", ")}
              label="Question Types"
              size="small"
              fullWidth
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default ExamPaperInfo;
